import * as constants from './constants';

const InitialStagesData = [{
  key: 'solutions',
  completed: false,
  curStep: 0,
  steps: [{
    key: 'step_1',
    name: 'tool_ui.solutions.step_1_name',
    completed: false,
    questions: [{
      key: 'q2',
      type: 'yes_no',
      answer: null,
      name: 'tool_ui.solutions.q2'
    }, {
      key: 'q3',
      type: 'yes_no',
      answer: null,
      name: 'tool_ui.solutions.q3'
    }, {
      key: 'q4',
      type: 'yes_no',
      answer: null,
      name: 'tool_ui.solutions.q4'
    }]
  }, {
    key: 'step_2',
    name: 'tool_ui.solutions.step_2_name',
    completed: false,
    questions: [{
      key: 'q5',
      type: 'yes_no',
      answer: null,
      name: 'tool_ui.solutions.q5'
    }, {
      key: 'q6',
      type: 'yes_no',
      answer: null,
      name: 'tool_ui.solutions.q6'
    }]
  }, {
    key: 'step_3',
    name: 'tool_ui.solutions.step_3_name',
    completed: false,
    questions: [{
      key: 'q7',
      type: 'yes_no',
      answer: null,
      name: 'tool_ui.solutions.q7'
    }, {
      key: 'q8',
      type: 'yes_no',
      answer: null,
      name: 'tool_ui.solutions.q8'
    }]
  }, {
    key: 'step_4',
    name: 'tool_ui.solutions.step_4_name',
    completed: false,
    questions: [{
      key: 'q9',
      type: 'yes_no',
      answer: null,
      name: 'tool_ui.solutions.q9'
    }, {
      key: 'q10',
      type: 'yes_no',
      answer: null,
      name: 'tool_ui.solutions.q10'
    }]
  }, {
    key: 'step_5',
    name: 'tool_ui.solutions.step_5_name',
    completed: false,
    questions: [{
      key: 'q11',
      type: 'yes_no',
      answer: null,
      name: 'tool_ui.solutions.q11'
    }, {
      key: 'q12',
      type: 'yes_no',
      answer: null,
      name: 'tool_ui.solutions.q12'
    }]
  }],
}, {
  key: 'devices',
  completed: false,
  curStep: 0,
  steps: [{
    key: 'step_1',
    name: 'tool_ui.devices.step_1_name',
    completed: false,
    questions: [{
      key: 'q13',
      type: 'choice',
      answer: null,
      name: 'tool_ui.devices.q13',
      choices: [{
        key: 'rover',
        text: 'tool_ui.devices.q13_r1'
      }, {
        key: 'coordinator',
        text: 'tool_ui.devices.q13_r2'
      }, {
        key: 'enabler',
        text: 'tool_ui.devices.q13_r3'
      }, {
        key: 'creator',
        text: 'tool_ui.devices.q13_r4'
      }]
    }, {
      key: 'q14',
      type: 'dropdown',
      answer: null,
      name: 'tool_ui.devices.q14',
      choices: [{
        key: 'home',
        text: 'tool_ui.devices.q14_r1'
      }, {
        key: 'work',
        text: 'tool_ui.devices.q14_r2'
      }, {
        key: 'hybrid',
        text: 'tool_ui.devices.q14_r3'
      }]
    }]
  }, {
    key: 'step_2',
    name: 'tool_ui.devices.step_2_name',
    completed: false,
    questions: [{
      key: 'q16',
      type: 'checkboxes',
      multiple: true,
      answer: [],
      name: 'tool_ui.devices.q16',
      choices: [{
        key: 'notebooks',
        text: 'tool_ui.devices.q16_r1'
      }, {
        key: 'desktops',
        text: 'tool_ui.devices.q16_r2'
      }, {
        key: 'tablets',
        text: 'tool_ui.devices.q16_r3'
      }, {
        key: 'monitors',
        text: 'tool_ui.devices.q16_r4'
      }, {
        key: 'phones',
        text: 'tool_ui.devices.q16_r5'
      }]
    }]
  }, {
    key: 'step_3',
    name: 'tool_ui.devices.step_3_name',
    completed: false,
    questions: [{
      key: 'q17',
      type: 'yes_no',
      answer: null,
      name: 'tool_ui.devices.q17'
    }, {
      key: 'q18',
      type: 'dropdown',
      answer: null,
      name: 'tool_ui.devices.q18',
      choices: [{
        key: 'small',
        text: 'tool_ui.devices.q18_r1'
      }, {
        key: 'medium',
        text: 'tool_ui.devices.q18_r2'
      }, {
        key: 'large',
        text: 'tool_ui.devices.q18_r3'
      }, {
        key: constants.NOT_APPLICABLE,
        text: 'tool_ui.devices.q18_r4'
      }]
    }]
  }],
}, {
  key: 'results',
  completed: false,
  link: '',
  downloadOnly: false,
}];

export default InitialStagesData;
